import useSignedUser from 'hooks/useSignedUser'
import {
  usePatientSidePanel,
  useProfessionalSidePanel
} from 'pages/Account/components/template/AccountSidePanel/hooks/usePatientSidePanel'
import { useMemo } from 'react'
import CollapsableMenu from './components/CollapsableMenu'
import * as Styles from './styles'

function CollapsableMenus() {
  const { signedUser } = useSignedUser()
  const patientSidePanel = usePatientSidePanel()
  const isCRMOrCRO = useMemo(() => {
    if (
      signedUser?.prescriber?.council === 'CRO' ||
      signedUser?.prescriber?.council === 'CRM' ||
      signedUser?.prescriber?.council === 'RMS'
    ) {
      return true
    }
    return false
  }, [signedUser])

  const profissionalSidePanel = useProfessionalSidePanel(isCRMOrCRO)

  return (
    <Styles.CollapsableMenusContainer>
      {signedUser?.registration_type === 1
        ? patientSidePanel.map((item) => (
            <CollapsableMenu
              title={item.title.label}
              icon={item.title.icon}
              to={item.title.to}
              subItems={item?.subItems}
              enabled={item.title.enabled}
              key={item.title.label}
            />
          ))
        : profissionalSidePanel.map((item) => (
            <CollapsableMenu
              title={item.title.label}
              icon={item.title.icon}
              to={item.title.to}
              subItems={item?.subItems}
              enabled={item.title.enabled}
              key={item.title.label}
            />
          ))}
    </Styles.CollapsableMenusContainer>
  )
}

export default CollapsableMenus
